/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PostV1UsersMutationRequest, PostV1UsersMutationResponse, PostV1Users422 } from "../../../types/PostV1Users.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPostV1UsersUrlClient() {
  const res = { method: 'POST', url: `/v1/users` as const }
  return res
}

/**
 * @summary Register new user
 * {@link /v1/users}
 */
export async function postV1UsersClient(data: PostV1UsersMutationRequest, config: Partial<RequestConfig<PostV1UsersMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostV1UsersMutationResponse, ResponseErrorConfig<PostV1Users422>, PostV1UsersMutationRequest>({ method : "POST", url : getPostV1UsersUrlClient().url.toString(), data : requestData, ... requestConfig })
  return res
}